import Vue from 'vue';

export default (context, formButton) => {
  return Vue.$http.post('/airbnb-direct-reservation', {
    confirmation_code: context.importOrUpdateAirbnbBookingConfirmationCode,
    rental_id: context.importOrUpdateAirbnbBookingRentalId,
  })
    .then(response => {
      if (response && response.status === 200) {
        formButton.innerHTML = 'Success';
        setTimeout(() => {
          formButton.disabled = false;
          formButton.innerHTML = 'Import';
        }, 5000);

      } else {
        failed(context, response);
      }
    }).catch(error => {
      alert('Error: ' + error.response.data.msg);
      formButton.innerHTML = 'Something went wrong';
      setTimeout(() => {
        formButton.disabled = false;
        formButton.innerHTML = 'Import';
      }, 5000);
    })
}



// WEBPACK FOOTER //
// ./src/app/services/admin/importOrUpdateAirbnbReservation.js